import { useState } from "preact/hooks";
import { GET, GET_IMPORT_DEVICE_STATUS_OPTION } from "../../../services";
import { IStateOption } from "../interfaces/state";

export const useGetOptions = () => {
  const [options, setOptions] = useState([] as IStateOption[]);

  const getImportDeviceStatusOption = async () => {
    try {
      const res: any = await GET(GET_IMPORT_DEVICE_STATUS_OPTION);
      const { options: opt } = res.result;
      setOptions(opt);
    } catch (error) {
      console.log("error", error);
    }
  };

  return {
    getImportDeviceStatusOption,
    options,
  };
};
